import { useMemo } from "react";
// eslint-disable-next-line no-restricted-imports -- TODO: update to `next/navigation` before using this component in App Router
import { useRouter } from "next/router";
import { parse } from "qs";

import { leaflyShopStringify } from "@/utils/qs";

const useSortQueryParam = () => {
  const { asPath } = useRouter();
  const [url, _hash] = asPath.split("#");
  const [path, query] = url.split("?");

  const { appliedSort, nonSortQueryParams } = useMemo(() => {
    const parsedQs = parse(query);
    const { sort: appliedSort, page: _page, ...nonSortQueryParams } = parsedQs;

    return {
      // * Assuming this hook is used to manage sort, we can confidently say it is a string record (see getUrlWithNewSort)
      appliedSort: appliedSort as { [key: string]: string },
      nonSortQueryParams,
    };
  }, [query]);

  const getUrlWithNewSort = (name: string, newFilterValue: string) => {
    return {
      pathname: path,
      query: leaflyShopStringify({
        ...nonSortQueryParams,
        sort: {
          [name]: newFilterValue,
        },
      }),
    };
  };

  const getUrlWithoutSort = () => {
    return {
      pathname: path,
      query: leaflyShopStringify({
        ...nonSortQueryParams,
      }),
    };
  };

  return {
    appliedSort,
    utils: {
      getUrlWithNewSort,
      getUrlWithoutSort,
    },
  };
};

export default useSortQueryParam;
